import React from 'react';
import { dispatch } from '../store';
import { openSnackbar } from '../store/reducers/snackbar';
import { IconButton, Tooltip } from '@mui/material';
import { CopyOutlined } from '@ant-design/icons';
import CustomTooltip from './CustomTooltip';

interface CopyTextIconButtonProps {
  textToCopy: string;
  dispatchText: string;
  alignedStyle?: boolean;
  xs?: boolean;
  size?: 'small' | 'medium' | 'large';
  iconColor?: string;
}

const CopyTextIconButton: React.FC<CopyTextIconButtonProps> = ({ textToCopy, dispatchText, alignedStyle = false, xs = false, size = 'small', iconColor }) => {
  const copyToClipboard = () => {
    navigator.clipboard
      .writeText(textToCopy)
      .then(() => {
        dispatch(
          openSnackbar({
            open: true,
            message: `${dispatchText} copied to clipboard.`,
            variant: 'alert',
            alert: {
              color: 'success'
            },
            close: true
          })
        );
      })
      .catch((err) => {
        dispatch(
          openSnackbar({
            open: true,
            message: `Failed to copy ${dispatchText}.`,
            variant: 'alert',
            alert: {
              color: 'error'
            },
            close: true
          })
        );
      });
  };

  return (
    <CustomTooltip title={`Copy ${dispatchText}`}>
      <IconButton
        size={size}
        color="primary"
        onClick={copyToClipboard}
        aria-label={`Copy ${dispatchText}`}
        sx={{
          color: iconColor,
          ...(alignedStyle
            ? {
                pb: 0.7,
                pl: 0.2,
                minWidth: 0,
                minHeight: 0,
                fontSize: xs ? '10px' : 0,
                width: 'auto',
                height: 'auto'
              }
            : {})
        }}
      >
        <CopyOutlined />
      </IconButton>
    </CustomTooltip>
  );
};

export default CopyTextIconButton;
